import { StudentDocumentAccessHistory } from './student-documents-accesshistory.model';

export class StudentDocuments {
  DocumentId: number;
  Name: string;
  DocumentType: string;
  FileType: string;
  Notes: string;
  DocumentFor: string;
  CreatedBy: string;
  CreatedOn: Date = undefined; // We do this for conversion
  FileName: string;
  FileBase64: string;
  FileMimeType: string;
  AccessHistory: StudentDocumentAccessHistory[];
  RecentAccessHistory: string;
  Delete: boolean;
  StudentName: string;
  StudentId: number;
  FamilyId: number;
  DocumentTypeId: number;
  PermissionsCategory: string;
}
